import React from 'react';
import { motion } from 'framer-motion';
import { FiCheck } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import clsx from 'clsx';

const Card = ({ challenge, isCompleted, player, onClick }) => {
  return (
    <motion.div
      layout
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      whileTap={{ scale: 0.96 }}
      onClick={onClick}
      className={clsx(
        "relative aspect-square cursor-pointer rounded-3xl transition-all duration-300",
        isCompleted
          ? "bg-slate-100 shadow-inner border border-slate-200"
          : "bg-white border border-slate-200/80 shadow-sm hover:shadow-lg hover:border-slate-300"
      )}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center p-5 text-center">
        {isCompleted && player && (
          <div
            className={`absolute top-3 right-3 w-7 h-7 rounded-full flex items-center justify-center ${
              player === 1 ? 'bg-indigo-500' : 'bg-rose-500'
            } text-white shadow-sm`}
          >
            <span className="text-[10px] font-black">{player}</span>
          </div>
        )}

        <div
          className={clsx(
            "mb-4 w-14 h-14 rounded-2xl flex items-center justify-center transition-all duration-300",
            isCompleted
              ? "bg-white border border-slate-200 text-slate-400"
              : `${challenge.gradient} text-white shadow-md`
          )}
        >
          <SafeIcon
            icon={isCompleted ? FiCheck : challenge.icon}
            className="w-6 h-6"
          />
        </div>

        <h3
          className={clsx(
            "font-bold text-xs leading-snug tracking-wide",
            isCompleted ? "text-slate-400" : "text-slate-800"
          )}
        >
          {challenge.title}
        </h3>
      </div>
    </motion.div>
  );
};

export default Card;